(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, {once:true}) : fn();

  function valueFor(id){
    const el=document.getElementById(id);
    return el ? String(el.value || '').trim() : '';
  }

  function syncSingleSeatVisibility(){
    const root=document.getElementById('custom-lott-builder') || document;
    const grid=root.querySelector('.cl-seat-grid, .cl2-seats');
    if(!grid) return;
    const ids=['cl-stand','cl-block','cl-row','cl-seat'];
    const slots=[...grid.children].slice(0,4);
    let visible=0;
    slots.forEach((slot,i)=>{
      const hasValue=!!valueFor(ids[i]);
      slot.classList.toggle('lott-seat-empty',!hasValue);
      if(hasValue) visible++;
    });
    grid.classList.toggle('lott-all-seats-empty',visible===0);
  }

  function removeSeasonCopy(){
    const direct=document.getElementById('cl-comp-season');
    if(direct){direct.textContent='';direct.setAttribute('aria-hidden','true');}
    document.querySelectorAll('.cl-comp-copy>b,.cl2-comp-copy>b,.lh2-ticket-head>div>b,.lh2-mini-ticket header>div>b').forEach(el=>el.remove());
  }

  function addBundleOffer(){
    const href='/products/custom-lott-bundle-3-lotts';
    const make=()=>{
      const a=document.createElement('a');
      a.className='lott-bundle-offer';
      a.href=href;
      a.innerHTML='<span>Building an archive?</span><b>3 custom Lotts · £49.99 →</b>';
      return a;
    };
    const targets=[
      document.querySelector('#custom-lott-builder .cl-submit, #custom-lott-builder .cl2-submit'),
      document.querySelector('#lh2-build-link, .lh-builder-cta')
    ].filter(Boolean);
    targets.forEach((target,i)=>{
      const parent=target.parentElement;
      if(!parent || parent.querySelector('.lott-bundle-offer')) return;
      const link=make();
      link.dataset.lottBundlePlacement=String(i+1);
      target.insertAdjacentElement('afterend',link);
    });
  }

  function bind(){
    removeSeasonCopy();
    syncSingleSeatVisibility();
    ['cl-stand','cl-block','cl-row','cl-seat'].forEach(id=>{
      const el=document.getElementById(id);
      if(el){el.addEventListener('input',syncSingleSeatVisibility);el.addEventListener('change',syncSingleSeatVisibility);}
    });
    addBundleOffer();

    // Keep fixes applied after competition/team renderers update the ticket DOM.
    const root=document.getElementById('custom-lott-builder');
    if(root && 'MutationObserver' in window){
      let raf=0;
      new MutationObserver(()=>{
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(()=>{removeSeasonCopy();syncSingleSeatVisibility();});
      }).observe(root,{childList:true,subtree:true,characterData:true});
    }
  }
  ready(bind);
})();
